



























































































































import IListTypesInbounds from '@/store/models/IListTypesInbounds';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';

@Component({
    components: {
        Snackbar
    }
})
export default class ListTypesInboundsSelector extends Vue {
    searchListTypesInbounds: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    sortBy: string = 'name';
    sortDesc: boolean = false;
    headers: any = [
        { text: 'Name', value: 'name' },
        { text: 'Actions', value: 'actions', sortable: false }
    ];
    editedIndex : number = -1;
    editedItem : IListTypesInbounds = {
        id: "",
        name: "",
        canDelete: true,
        idCompany: ""
    }
    defaultItem : IListTypesInbounds = {
        id: "",
        name: "",
        canDelete: true,
        idCompany: ""
    }

    @Prop({ type: Array, required: true })
    ListTypesInboundsList !: IListTypesInbounds[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];

    selectedListTypesInbounds : IListTypesInbounds[] = [];

    get formTitle() { return this.editedIndex === -1 ? 'New Inbound type' : 'Edit Inbound type'; }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    resetListTypesInbounds() {
        this.selectedListTypesInbounds = [];
    }

    editListTypesInbounds (item: any, dbox = true) {
        this.editedIndex = this.ListTypesInboundsList.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
    }

    saveListTypesInbounds () {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            if (this.editedIndex > -1 || this.selectedListTypesInbounds[0]) {
                this.close();
                this.$emit('editListTypesInbound', this.editedItem);
                Object.assign(this.ListTypesInboundsList[this.editedIndex], this.editedItem);
            } else {
                this.selectedListTypesInbounds[0] = this.editedItem;
                this.$emit('saveListTypesInbound', this.editedItem);
            }
            this.close();
        } else {
            this.$emit('showMessageWarning', 'All required fields must be filled out');
        }
    }

    deleteListTypesInbounds (TypesInbounds: IListTypesInbounds) {
        this.$emit('deleteListTypesInbound', TypesInbounds);
        this.close();
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    selectListTypesInbounds(item : any) : void {
        if (!this.selectedListTypesInbounds.includes(item)) {
            this.selectedListTypesInbounds = [];
            this.selectedListTypesInbounds = [item];
        } else {
            this.selectedListTypesInbounds = [];
        }
    }
    
    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
